import React from 'react';
import { FaStar } from 'react-icons/fa';

const RatingFilter = ({ ratingFilter, setRatingFilter }) => {
  const handleRatingChange = (event) => {
    setRatingFilter(Number(event.target.value));
  };

  return (
    <div className="filter-control-item">
      <label htmlFor="rating-filter" className="filter-control-label">
        <FaStar className="icon-green" /> Min Rating
      </label>
      <select
        id="rating-filter"
        className="filter-select-custom"
        value={ratingFilter}
        onChange={handleRatingChange}
        aria-label="Filter by minimum rating"
      >
        <option value="1">Any Rating (1+ ⭐)</option>
        <option value="5">Decent (5+ ⭐)</option>
        <option value="6">Good (6+ ⭐)</option>
        <option value="7">Great (7+ ⭐)</option>
        <option value="8">Masterpiece (8+ ⭐)</option>
      </select>
    </div>
  );
};

export default RatingFilter;